import type { RouteObject } from 'react-router';

import { UserDetailPage } from './UserDetail';

/**
 * `/users/:userId` — one account. One `RouteObject`, so the file is
 * `.route.tsx` singular; both of the feature's routes are aggregated one level
 * up in `users.routes.tsx`.
 *
 * **The identifier is URL state and nothing else is.** The page holds no filter,
 * no tab, and no panel selection, so the address is the account and the browser's
 * history walks accounts rather than states of one.
 *
 * It adds no loader: the console layout route already runs the guard chain, and
 * every one of the three reads this page composes is authorized by its own
 * service on the request itself. The guard decides **navigation** — that an
 * `operator` reaches this route while `backend-auth` still refuses them the
 * block, the role write, and the biography write is the design, not a gap.
 */
export const userDetailRoute: RouteObject = {
  path: 'users/:userId',
  element: <UserDetailPage />,
};
